export class MediaPointConstant {
    static MediaPointSm = 576;
    static MediaPointMd = 768;
}